// extracted by mini-css-extract-plugin
export default {"link":"navbutton_link__N-J4q","img":"navbutton_img__vJDnC","text":"navbutton_text__wpoEi"};